import Network from '../network.js'

export default {
  fetch(request) {
    return Network.get('/prospects/self', request, true)
  },
  sync(request) {
    return Network.put('/prospects/self', request, true)
  },
  syncLanguage(request) {
    return Network.put('/prospects/self/language', request, true)
  },
  phoneVerificationStatus(studyId) {
    return Network.get('/prospects/self/phone-verification', studyId ? { studyId } : null, true)
  },
  sendPhoneCode(request) {
    return Network.post('/prospects/self/phone-verification/send', request, true)
  },
  checkPhoneCode(request) {
    return Network.post('/prospects/self/phone-verification/check', request, true)
  }
}
